import './Search.scss';

import { coreActions } from '@sonar-software/sonar-core';
import { DarkTheme } from '@ui/themes';
import { getSonarObjectTypeId } from '@sonar-software/sonar-ts-lib';
import { SearchInput } from '@ui/general';
import { SearchItems } from './SearchItems';
import { sonarObjectsSearchDataSelector } from './arch/selectors';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { When } from 'react-if';

import { CATEGORY_SEARCH_LIMIT, COPY_SPECIFIC, QUICK_SEARCH_LIMIT } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';

export const Search: React.FC = () => {
	const [ query, setQuery ] = useState('');
	const [ currentType, setCurrentType ] = useState<SonarObjectType>();

	const getSearch = useAction(coreActions.requestGetCoreSonarObjectsSearch);
	const resetSearch = useAction(coreActions.resetGetCoreSonarObjectsSearch);
	const searchData = useSonarSelector(sonarObjectsSearchDataSelector);

	const handleOnChange = useCallback(
		(value: string) => {
			setQuery(value);
			if (value?.length >= 3) {
				getSearch({
					maxResultsPerType: currentType ? CATEGORY_SEARCH_LIMIT : QUICK_SEARCH_LIMIT,
					objectTypeFilters: currentType ? [ getSonarObjectTypeId(currentType) ] : undefined,
					queryString: value
				});

				return;
			}

			if (!value?.length || (!currentType && searchData !== null)) {
				setCurrentType(undefined);
				resetSearch();
			}
		},
		[ currentType, getSearch, resetSearch, searchData ]
	);

	const handleTypeChange = useCallback(
		(type: SonarObjectType) => {
			setCurrentType(type);

			getSearch({
				maxResultsPerType: type ? CATEGORY_SEARCH_LIMIT : QUICK_SEARCH_LIMIT,
				objectTypeFilters: [ getSonarObjectTypeId(type) ],
				queryString: query
			});
		},
		[ getSearch, query ]
	);

	const showItems = currentType || query.length >= 3;

	return (
		<DarkTheme>
			<div id='search'>
				<SearchInput
					autoFocus
					id='quick-find'
					onChange={ handleOnChange }
					placeholder={ COPY_SPECIFIC.SEARCH_ENTITIES } />
			</div>
			<When condition={ showItems }>
				<SearchItems
					currentType={ currentType }
					onTypeSelection={ handleTypeChange } />
			</When>
		</DarkTheme>
	);
};
